<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›"
                            :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn id="btnSave" type="button" elevation="0" color="primary" dark
                            @click="page.isNew ? add() : update()" :loading="dataset.loading">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/ocorrencias">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-select dense :items="dataset.occurrenceTypes" label="Tipo"
                                                v-model="dataset.data.type" item-value="id" item-text="name" outlined
                                                :rules="[$rules.required]" required hide-details="auto">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field dense label="Data do ocorrido" type="date"
                                                v-model="dataset.data.date" required outlined hide-details="auto"
                                                :rules="[$rules.required]">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <student-autocomplete
                                                v-model="dataset.data.student_id"
                                                :selected-items="dataset.students"
                                                label="Aluno"
                                                @selected="setSelectedStudent"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-checkbox v-model="dataset.data.request_signature"
                                                label="Assinatura obrigatório" color="primary"
                                                hide-details></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <p class="font-weight-bold">Descrição</p>
                                            <tiptap-vuetify class="custom-editor-long" v-model="dataset.data.description"
                                                :rules="[$rules.required]" :extensions="extensions"
                                                hide-details="auto" />
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

    </v-container>
</template>

<script>

import occurrenceTypes from "@/common/data/occurrence-types.data"
import StudentAutocomplete from "@/layouts/components/StudentAutocomplete.vue"

import axios from "axios"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Paragraph
} from 'tiptap-vuetify'

export default {
    name: "OccurrenceDetails",

    components: {
        'tiptap-vuetify': TiptapVuetify,
        StudentAutocomplete,
    },

    data: () => ({
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            breadcrumbItems: [],
            occurrenceTypes: occurrenceTypes,
            data: {},
            studentLoading: false,
            students: [],
            loading: false,
        },
        dataForm: {
            validForm: true,
            updateLoading: false,
            removeLoading: false,
        },
        extensions: [
            Underline,
            Strike,
            Italic,
            Bold,
            Paragraph,
        ],
    }),

    created() {
        this.page.isNew = this.$route.params.id == "novo"

        this.loadData()
    },

    methods: {
        goBack() {
            this.$router.replace("/ocorrencias");
        },

        async loadData() {
            this.setPage();
            this.listBreadCrumbItems();

            await this.load();
        },

        setPage() {
            this.page.title = `Detalhes da Ocorrência`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Listagem de ocorrências",
                disabled: false,
                to: "/ocorrencias",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: this.page.isNew ? `Incluir` : `Detalhes da ocorrências`,
                disabled: true,
                exact: true,
            });
        },

        async load() {
            if (this.$route.params.id == "novo") return;

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/v1/occurrences/${this.$route.params.id}`);

                this.dataset.data = result.data.content
                this.dataset.students = this.dataset.data.student ? [this.dataset.data.student] : [];

            } catch (error) {
                this.$dialog.notify.error('Ocorreu um erro ao buscar a ocorrência, tente novamente!', {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        setSelectedStudent(student) {
            this.dataset.students = student ? [student] : [];
            this.dataset.data = { ...this.dataset.data, student, student_id: student ? student.id : null };
        },

        async add() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja incluir a ocorrência?',
                title: 'Incluir ocorrência',
                actions: {
                    false: 'Cancelar',
                    true: 'Salvar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.post('/api/v1/occurrences', payload);

                this.$dialog.notify.info("Ocorrência salva com sucesso!", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }

        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar a ocorrência?',
                title: 'Atualizar ocorrência',
                actions: {
                    false: 'Cancelar',
                    true: 'Atualizar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const payload = this.buildPayload();

            try {
                const response = await axios.patch(`/api/v1/occurrences/${this.$route.params.id}`, payload, { config: { headers: { "Content-Type": "application/json" } } });

                this.$dialog.notify.info("Ocorrência salva com sucesso", { position: "top-right", timeout: 2000 });

                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataForm.addLoading = false;
            }
        },

        buildPayload() {
            const data = {
                description: this.dataset.data.description,
                type: this.dataset.data.type,
                date: this.dataset.data.date,
                student_id: this.dataset.data.student_id,
                request_signature: this.dataset.data.request_signature,
            }

            return data;
        },




    },
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}
</style>
